import {isLargeScreen} from "~/helpers";
export const state = () => ({
  fullSideBar:isLargeScreen()
});
export const getters = {

};
export const mutations = {
  TOGGLE_MENU(state,toggle){
    state.fullSideBar = isLargeScreen() ? toggle : false
  },
};
export const actions = {
  async toggleMenu({commit}, params) {
    commit('TOGGLE_MENU', params);
  }
};
